// extracted by mini-css-extract-plugin
module.exports = {"footer-menu":"FooterMenu_footer-menu__ywBTl","footer-menu-list":"FooterMenu_footer-menu-list__8DtvI"};